(() => {
  if (window.ceikaTechnicalSliderLoaded) return;
  window.ceikaTechnicalSliderLoaded = true;
  function enhance(track) {
    if (track.dataset.sliderReady) return;
    const slides = [...track.children];
    if (slides.length < 2) return;
    track.dataset.sliderReady = 'true';
    track.classList.add('ceika-slider-track');
    const selector = document.createElement('div');
    selector.className = 'ceika-slider-selector';
    selector.setAttribute('role', 'group');
    const heading = track.closest('article')?.querySelector('h4') || track.closest('.ceika-info__technical')?.querySelector('.ceika-info__eyebrow');
    if (heading) selector.setAttribute('aria-label', heading.textContent.trim());
    const buttons = slides.map((slide, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = slide.querySelector('h4,h5')?.textContent.trim() || String(index + 1);
      button.setAttribute('aria-pressed', String(index === 0));
      button.addEventListener('click', () => {
        const rtl = getComputedStyle(track).direction === 'rtl';
        const delta = rtl ? slide.getBoundingClientRect().right - track.getBoundingClientRect().right : slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollBy({left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
      selector.append(button);
      return button;
    });
    track.before(selector);
    let frame;
    let selected = 0;
    const resize = () => {
      const brakeGuide = track.closest('[data-ceika-product-information="bbk"]');
      const pairedTracks = brakeGuide ? [...brakeGuide.querySelectorAll('[data-technical-track]')] : [];
      if (pairedTracks.length === 2) {
        const cards = pairedTracks.flatMap(item => [...item.children]);
        cards.forEach(card => { card.style.minHeight = ''; });
        const height = Math.ceil(Math.max(...cards.map(card => card.getBoundingClientRect().height)));
        cards.forEach(card => { card.style.minHeight = height + 'px'; });
        pairedTracks.forEach(item => { item.style.height = (height + 26) + 'px'; });
      } else {
        slides.forEach(slide => { slide.style.minHeight = ''; });
        track.style.height = `${slides[selected].getBoundingClientRect().height + 26}px`;
      }
    };
    matchMedia('(min-width: 761px)').addEventListener('change', resize);
    const observer = new ResizeObserver(resize);
    slides.forEach(slide => observer.observe(slide));
    resize();
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const bounds = track.getBoundingClientRect();
        const center = (bounds.left + bounds.right) / 2;
        let active = 0, distance = Infinity;
        slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const current = Math.abs((rect.left + rect.right) / 2 - center);
          if (current < distance) { active = index; distance = current; }
        });
        selected = active;
        resize();
        buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
      });
    }, {passive: true});
  }
  function init() {
    document.querySelectorAll('[data-ceika-product-information="coilover"] .ceika-info__technical').forEach(technical => {
      if (technical.querySelector('.ceika-coil-technical-slider')) return;
      const cards = [...technical.children].filter(el => el.tagName === 'ARTICLE');
      if (cards.length < 2) return;
      const shell = document.createElement('div');
      shell.className = 'ceika-slider-shell ceika-coil-technical-slider';
      const track = document.createElement('div');
      track.dataset.technicalTrack = '';
      cards[0].before(shell);
      shell.append(track);
      cards.slice(0, -1).forEach(card => track.append(card));
    });
    document.querySelectorAll('[data-technical-track]').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
